/**
 * frontend/src/pages/valuation/_TuningSignoffColumn.tsx
 *
 * VAL-TUNING-SPLIT-1 — the sticky right-hand preview/acknowledgement/
 * continue column of ValuationTuning.tsx, split out under
 * docs/FILE_SIZE_POLICY.md. Presentational only. The move to sign-off is
 * the step footer's (VAL-PATH-FOOTER), on the screen.
 */
import type { BasisBlock, ComputedPayload } from '@/types/valuationB3'
import { TuningPreview } from './_TuningPreview'
import { MarketOnlyAck } from './_MarketOnlyAck'

interface TuningSignoffColumnProps {
  computed: ComputedPayload | null
  basis: BasisBlock | null
  pending: boolean
  runError: string | null
  blockers: string[]
  warnings: string[]
  isMarketOnly: boolean
  acknowledgeMarketOnly: boolean
  onAcknowledgeMarketOnly: (value: boolean) => void
  valueKind?: 'concluded' | 'calculated' | null
}

export function TuningSignoffColumn({
  computed,
  basis,
  pending,
  runError,
  blockers,
  warnings,
  isMarketOnly,
  acknowledgeMarketOnly,
  onAcknowledgeMarketOnly,
  valueKind,
}: TuningSignoffColumnProps) {
  return (
    <div className="min-w-0 space-y-4 lg:sticky lg:top-4 lg:self-start">
      {/* VAL-UI-FIX-1 R2 — sticky keeps the preview on screen (R2a); this
         wrapper caps it to the viewport and lets it scroll internally so
         a tall preview never pushes its own top off-screen (R2b). Only
         the preview is capped — the acknowledgement checkbox stays
         outside it, as a plain sibling in the sticky
         column, so it is always visible without having to scroll the
         preview to find them. lg:-only (R2c); left column untouched (R2d). */}
      <div className="lg:max-h-[calc(100vh-7rem)] lg:overflow-y-auto">
        <TuningPreview
          computed={computed}
          basis={basis}
          stale={pending}
          error={runError}
          blockers={blockers}
          warnings={warnings}
          valueKind={valueKind}
        />
      </div>
      {isMarketOnly && (
        <MarketOnlyAck checked={acknowledgeMarketOnly} onChange={onAcknowledgeMarketOnly} />
      )}
    </div>
  )
}
